import React from 'react';
import { NavLink } from 'react-router-dom';
import Page from '../../components/_layout/Page';
import WidgetsGrid from '../../components/_layout/WidgetsGrid';

export default function Admin({ subRoutes }) {
  return (
    <Page header="Администрирование" className="admin-page">
      <WidgetsGrid
        items={subRoutes.filter((sr) => !!sr?.path).map((sr) => ({ url: sr.path, name: sr.title }))}
      />
    </Page>
  );
}
